<template>
  <DialogHeader>
    <template #right>
      <div
        v-if="!loading"
        class="font-medium text-green-900 cursor-pointer"
        @click="handleSave"
      >
        Save
      </div>
      <Icon
        v-else
        name="Loading"
        :size="14"
        class="stroke-gray-800 animate-spin"
      />
    </template>
    Edit {{ type }}
  </DialogHeader>
  <DialogContent>
    <UiInput v-model="name" :label="label" :disabled="loading" auto-focus />
    <Message v-if="error?.message" class="mt-4" type="error">
      {{ error.message }}
    </Message>
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-1/2 tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      :disabled="loading"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton
      class="w-1/2 tablet-h:w-auto"
      primary
      :disabled="loading"
      :loading="loading"
      @click="handleSave"
    >
      Save
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { Icon, UiButton, UiInput, Message } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { computed, ref } from 'vue'
import {
  CopyrightOwnersDocument,
  CopyrightOwnerType,
  useUpdateCopyrightOwnerMutation,
  type CopyrightOwner,
  type CopyrightOwnersQuery,
} from '@/shared/graphql/legacy/generated'

const { close } = useDialog()

const props = defineProps<{
  owner: CopyrightOwner
}>()

const {
  loading,
  mutate: editCopyrightOwner,
  error,
} = useUpdateCopyrightOwnerMutation()

const name = ref(props.owner.name)

const type = computed(() => {
  if (props.owner.type === CopyrightOwnerType.Personal) return 'copyright owner'
  return 'organization'
})

const label = computed(() =>
  props.owner.type === CopyrightOwnerType.Personal
    ? 'Name'
    : 'Orgnaization name'
)

const handleSave = async () => {
  await editCopyrightOwner(
    {
      id: props.owner.id,
      name: name.value,
    },
    {
      update(cache, { data }) {
        cache.updateQuery<CopyrightOwnersQuery>(
          { query: CopyrightOwnersDocument },
          (response) => {
            if (!response || !data) return

            return {
              ...response,
              copyrightOwners: {
                ...response.copyrightOwners,
                items: response.copyrightOwners.items.map((owner) => {
                  if (owner.id === props.owner.id) {
                    return { ...owner, name: name.value }
                  }
                  return owner
                }),
              },
            }
          }
        )
      },
    }
  )

  close()
}
</script>
